<template>
	<div class="view-venue-listpreview">
		<ViewVenueList
			v-bind:venueCollection="venueCollection"
			v-if="venueCollection.length > 0"
			v-on:select="Handle_OnClickVenue"
		/>

		<!-- If we have no venues, assume it's user favorites -->
		<ViewUiStateNoFavorites v-else-if="emptyState === 'no-favorites'" />

		<!-- Otherwise, show loading state -->
		<ViewUiStateLoader v-else-if="emptyState === 'loading'" />
	</div>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Venue list component with support for different empty states.
	 *
	 * Displays a list of venue cards and handles empty state rendering
	 * for loading and no-favorites scenarios.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueListPreview extends ViewBase {
		/**
		 * The empty state to display when collection is empty.
		 *
		 * @type string
		 */
		@Prop({ default: 'loading' })
		public emptyState!: 'loading' | 'no-favorites' | 'none';

		/**
		 * Collection of venues to display.
		 *
		 * @type ChalkySticks.Collection.Venue
		 */
		@Prop({ required: true })
		public venueCollection!: ChalkySticks.Collection.Venue;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle venue card click.
		 *
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return void
		 */
		protected Handle_OnClickVenue(venueModel: ChalkySticks.Model.Venue): void {
			this.$emit('venue:select', venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-listpreview {
		height: 100%;
	}
</style>
